import React from 'react';
class DownloadImage extends React.Component {
constructor(props){
    super(props);
    this.state={
        imgURL:this.props.imageURL
    }
    } 
componentDidUpdate(prevProps){
    if(prevProps.imageURL!==this.props.imageURL){
        let url = this.props.imageURL;
        url = this.props.imageURL.substr(0,url.length-5);
    this.setState({imgURL:url})
    console.log(this.state.imgURL)
    }
}
componentDidMount(props){
    let url = this.props.imageURL;
    url = this.props.imageURL.substr(0, url.length - 5);
    this.setState({ imgURL: url })
    console.log(this.state.imgURL)
}
    render() {
        
        return (
           
            <React.Fragment>
                <a className="download-btn"href={this.props.videoURL?this.props.videoURL:this.props.imageURL} download={"High Quality Image"}>{this.props.videoURL?"Download Video":"Download Image"}</a>
                <p>If above download button not works Right click on the image to save the image.</p>
                <img className="orginal-img" src={this.state.imgURL} alt="Instagram"></img>
               
            </React.Fragment>
        )
    }
}
export default DownloadImage;